import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";

const RangesInput = (props) => (
  <ReferenceInput {...props} reference="user-payments/ranges">
    <SelectInput optionText="name" />
  </ReferenceInput>
);
export default RangesInput;
